import {Injectable} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {FieldHelperService} from '@app/services/util/field-helper.service';
import {Subscription} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class VehicleExpensesIncomesService {

  private subscription: Subscription;

  constructor(private fieldHelperService: FieldHelperService) {
  }

  // `item` is the repeater row the dialog is editing, and it is required: the
  // repeater's FormArray holds every existing row, so the row in question sits at
  // index N, not 0. Reading index 0 (as this did) only ever hit the right row on a
  // vehicle with no costs yet, which is why the type -> title auto-fill silently
  // did nothing everywhere else. (BRIEFD-7352)
  public onIncomeOrExpenseFormSetup = (field, formGroup: FormGroup, item: FormGroup) => {
    this.subscription = new Subscription();

    const fieldsControls = (item?.controls?.value as FormGroup)?.controls ?? [];

    if (field.config.typeId === 'briefd.vehicle.expenses.expenses_repeater') {
      const typeField = this.fieldHelperService.getSubFieldByTypeId('briefd.vehicle.expenses.expense_type', field);
      const titleField = this.fieldHelperService.getSubFieldByTypeId('briefd.vehicle.expenses.expense_title', field);
      const allDropdownValues = typeField.config.choices.map((choice) => Object.values(choice)[0]);

      this.subscription.add(fieldsControls[typeField.fieldUuid]?.valueChanges.subscribe((value) => {
        // Title missing or Dropdown value
        if (!fieldsControls[titleField.fieldUuid].value || allDropdownValues.includes(fieldsControls[titleField.fieldUuid].value)) {
          // Only self to prevent problems with formGroup saving value
          fieldsControls[titleField.fieldUuid].setValue(Object.values(value ?? {})?.[0] || '', {onlySelf: true, emitEvent: false});
        }
      }));
    }

    if (field.config.typeId === 'briefd.vehicle.expenses.income_repeater') {
      const typeField = this.fieldHelperService.getSubFieldByTypeId('briefd.vehicle.expenses.income_type', field);
      const titleField = this.fieldHelperService.getSubFieldByTypeId('briefd.vehicle.expenses.income_title', field);
      const allDropdownValues = typeField.config.choices.map((choice) => Object.values(choice)[0]);

      this.subscription.add(fieldsControls[typeField.fieldUuid]?.valueChanges.subscribe((value) => {
        // Title missing or Dropdown value
        if (!fieldsControls[titleField.fieldUuid].value || allDropdownValues.includes(fieldsControls[titleField.fieldUuid].value)) {
          // Only self to prevent problems with formGroup saving value
          fieldsControls[titleField.fieldUuid].setValue(Object.values(value ?? {})?.[0] || '', {onlySelf: true, emitEvent: false});
        }
      }));
    }

    return this.subscription;
  };
}
